export const salary = [
  {
    value: '£0 - £30,000',
    label: '£0 - £30,000',
  },{
    value: '£30,000 - £50,000',
    label: '£30,000 - £50,000',
  },{
    value: '£50,000 - £100,000',
    label: '£50,000 - £100,000',
  },{
    value: '£100,000 +',
    label: '£100,000 +',
  },
];
